import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { TWILIO_INTEGRATION_PATH } from '../api';
import { TwilioIntegrationInterface, TwilioIntegrationPostInterface } from '../types';
export function useTwilioActions() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== postFetcher) {
    t2 = data => postFetcher(TWILIO_INTEGRATION_PATH, data);
    $[2] = postFetcher;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== deleteFetcher) {
    t3 = () => deleteFetcher(TWILIO_INTEGRATION_PATH);
    $[4] = deleteFetcher;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      postIntegration: t2,
      deleteIntegration: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}